export const IMPORT_CITATION_BUTTON_ID = 'import-button'
export const RADIO_BUTTON_WITHOUTABSTRACTS_ID = 'without-abstracts'
export const RADIO_BUTTON_WITHABSTRACTS_ID = 'with-abstracts'
export const IMPORT_SUMMARY_CONTAINER = 'import-summary'
